import { useTranslation } from 'next-i18next';
import styles from './restaurant-card-content.module.scss';
import { isSome, Maybe } from '@crocodille/util';
import { formatDistance } from '@crocodille/bbdomu-i18n';
import cn from 'classnames';

interface RestaurantCardContentProps {
  readonly name: string;
  readonly address: string;
  readonly openFrom: Maybe<string>;
  readonly openTo: Maybe<string>;
  readonly deliveryFrom: Maybe<string>;
  readonly deliveryTo: Maybe<string>;
  readonly distance: number | null | undefined;
}
const RestaurantCardContent: React.FC<RestaurantCardContentProps> = ({
  name,
  address,
  openFrom,
  openTo,
  deliveryFrom,
  deliveryTo,
  distance,
}) => {
  const { t } = useTranslation();
  const addressWithoutPostcode = address.replace(/,\s*\d{5}$/, '').trim();

  return (
    <div className={styles.description}>
      <div>
        <div className={styles.title}>{name}</div>
        <div className={styles.address}>{addressWithoutPostcode}</div>
      </div>
      <table>
        <tbody>
          <tr className={styles.openingHours}>
            {isSome(openFrom) && isSome(openTo) ? (
              <>
                <td>{t('branch.open')}</td>
                <td>
                  {openFrom} - {openTo}
                </td>
              </>
            ) : (
              <td colSpan={2}>{t('branch.closed')}</td>
            )}
          </tr>
          <tr className={styles.deliveryHours}>
            {isSome(deliveryFrom) && isSome(deliveryTo) ? (
              <>
                <td>{t('branch.delivery')}</td>
                <td>
                  {deliveryFrom} - {deliveryTo}
                </td>
              </>
            ) : (
              <td colSpan={2}>{t('branch.closed_delivery')}</td>
            )}
          </tr>
        </tbody>
      </table>
      {isSome(distance) && (
        <div
          className={cn(styles.distance, {
            [styles.distanceFar]: distance / 1000 >= 2,
          })}
        >
          {t('branch.distance')} <span>{formatDistance(distance)}</span>
        </div>
      )}
    </div>
  );
};

export default RestaurantCardContent;
